import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { MainHeaderMenuService } from '../../services/main-header-menu.service';
import { IsValidOTP, IsValidPassword, MustMatch } from '../../validation';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { LoginService } from '../../services/login.service';
import { ProfileService } from '../../services/profile.service';
import { ClientDataService } from '../../services/client-data.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from '../../validation';
import { CodifyLoginService } from '../../services/codify-login.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-codify-forgot-password',
  templateUrl: './codify-forgot-password.component.html',
  styleUrls: ['./codify-forgot-password.component.scss']
})
export class CodifyForgotPasswordComponent {
  @ViewChild('ngCodifyOtpInput', { static: false }) ngCodifyOtpInput: any;
  @ViewChild('userid') userid: ElementRef;
  @ViewChild('newpassword') newpassword: ElementRef;
  IsChangePass: boolean = true;
  IsOTPVerify: boolean = false;
  IsNewPass: boolean = false;
  ChangePassForm: FormGroup;
  ChangePassSubmitted: boolean = false;
  OTPForm: FormGroup;
  OTPFormSubmitted: boolean = false;
  SetPassForm: FormGroup;
  SetPassFormSubmitted: boolean = false;
  UserType: any;
  logo: string;
  IsMobile: boolean = false;
  logoWidth: string;
  logoHeight: string;
  NavHeight: string;
  CompanyName: string;
  SubBrokerId: any;
  MobileNo: any;
  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  otp: any;
  CodifyValidateRes: any
  CodifyOTPForm: FormGroup;
  ForgetPass: boolean = false;
  ResetPassToken: any;
  IsShowInvalidOTPMsg: boolean = false;
  config = {
    length: 6,
    inputClass: 'OTPBox',
    allowNumbersOnly: true,
    inputStyles: {
      'text-security': 'disc',
      '-webkit-text-security': 'disc',
      '-moz-text-security': 'disc'
    },
    disableAutoFocus: false
  }
  constructor(private LoginService: CodifyLoginService,
    private Loader: CustomLoaderService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private formBuilder: FormBuilder,
    private router: Router,
    private EncrdecrService: EncrdecrService,
    private ProfileService: ProfileService,
    private ClientDataService: ClientDataService,
    private route: ActivatedRoute,
    private bsModalRef: BsModalRef,
    private renderer: Renderer2) {
    this.CodifyOTPForm = this.formBuilder.group({
      OTP: ['', [Validators.required, Validators.minLength(6)]]
    });
  }
  get codifyOTPForm() {
    return this.CodifyOTPForm.controls;
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])

  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }
  ngOnInit() {

    this.logo = sessionStorage.getItem('logo');
    this.CompanyName = this.ClientDataService.GetCompanyName();
    if (this.CompanyName == 'Mahindra') {
      this.logoWidth = '330px';
      this.logoHeight = '120px';
      this.NavHeight = '40px';
      $('.MainOuter').css('min-height', window.innerHeight - 145);
    }
    else if (this.CompanyName == 'AU') {
      this.logoWidth = '130px';
      this.logoHeight = '60px';
      this.NavHeight = '62px';
      $('.MainOuter').css('min-height', window.innerHeight - 0);
    }
    else if (this.CompanyName == 'YesSecurities') {
      this.logoWidth = '150px';
      this.logoHeight = '60px';
      this.NavHeight = '62px';
      $('.MainOuter').css('min-height', window.innerHeight - 75);
    }
    this.getCompanyDetails();
    const CorporateFag = sessionStorage.getItem('Vbhs@#%LMKIo=');
    if (CorporateFag == 'C') {
      ////////
      this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      //this.ShowHideHeaderMenu.hide();
      this.ChangePassForm = this.formBuilder.group({
        Trans_Type: "ForgotPassword",
        USER_TYPE: [this.UserType],
        createDate: [Date.now()],
        VERIFICATION_ID: ['', [Validators.required]],
        // Email: ['', [Validators.required,Validators.email]],
      });
      this.OTPForm = this.formBuilder.group({
        OTP: [''],
        USER_TYPE: [this.UserType],
        USER_ID: [''],
      });

      this.SetPassForm = this.formBuilder.group({
        Password: ['', [Validators.required, Validators.pattern(IsValidPassword)]],
        NEW_PASS: ['', Validators.required],
        USER_TYPE: [this.UserType],
        USER_ID: [''],
        OTP: ['']
      }, {
        validator: MustMatch('Password', 'NEW_PASS')
      });

      if (this.IsChangePass == true) {
        document.getElementById("userid").focus();
      }
      else {
        document.getElementById("userid").blur();
        document.getElementById("new_password").focus();
      }

    }
    else {
      // this.router.navigateByUrl("**");
      this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));
      console.log("userType: ", this.UserType);
      //this.ShowHideHeaderMenu.hide();
      this.ChangePassForm = this.formBuilder.group({
        Trans_Type: "ForgotPassword",
        USER_TYPE: [this.UserType],
        createDate: [Date.now()],
        VERIFICATION_ID: ['', [Validators.required]],
        // Email: ['', [Validators.required,Validators.email]],
      });
      this.OTPForm = this.formBuilder.group({
        OTP: [''],
        USER_TYPE: [this.UserType],
        USER_ID: [''],
      });

      this.SetPassForm = this.formBuilder.group({
        Password: ['', [Validators.required, Validators.pattern(IsValidPassword)]],
        NEW_PASS: ['', Validators.required],
        USER_TYPE: [this.UserType],
        USER_ID: [''],
        OTP: ['']
      }, {
        validator: MustMatch('Password', 'NEW_PASS')
      });
    }
    this.SetViewPort(window.innerWidth);

  }
  ngAfterViewInit() {
    let loaderInterval = setInterval(() => {
      let str = document.readyState;
      if (str == 'complete') {
        let id = $('.ng-otp-input-wrapper .otp-input:first-child').attr('id');
        console.log(id);

        this.ngCodifyOtpInput.focusTo(id);
        clearInterval(loaderInterval)
      }
    }, 1000);
    debugger;

    if (this.IsChangePass == true) {
      this.renderer.selectRootElement(this.userid.nativeElement).focus();
    }
  }
  get r() {
    return this.ChangePassForm.controls;
  }
  get o() {
    return this.OTPForm.controls;
  }
  get p() {
    return this.SetPassForm.controls;
  }
  onSubmitChangePass(para: number) {
    debugger
    this.ChangePassSubmitted = true;

    if (this.ChangePassForm.invalid) {
      return;
    } else {
      if (para == 0) {
        this.ForgetPass = true;
        debugger
        this.GetClientPanInfo(this.ChangePassForm.value.VERIFICATION_ID);
      }
    }

  }
  onSubmitChangePass_old(para: number) {
    //////
    debugger
    this.ChangePassSubmitted = true;
    if (this.ChangePassForm.invalid) {
      return;
    }
    else {
      ////////
      this.Loader.show();
      this.ChangePassForm.controls['createDate'].setValue(Date.now());
      if (this.UserType === 2) {
        this.ChangePassForm.value.VERIFICATION_ID = this.ChangePassForm.value.VERIFICATION_ID;
      } else {
        this.ChangePassForm.value.VERIFICATION_ID = this.ChangePassForm.value.VERIFICATION_ID;
      }
      let DataBody = JSON.stringify(this.ChangePassForm.value);
      //alert(DataBody);
      // this.LoginService.SendOTP_NSE(DataBody).subscribe(
      //   (res: any) => {
      //     if (res.ID != -100) {
      //       if (res.code == 200) {
      //         if (para === 0) {
      //           this.ActiveOTPTab();
      //         }
      //         else {
      //           this.CallAlertModal("OTP sent successfully on registered email id.");
      //         }
      //       }
      //     }
      //     else {
      //       this.CallAlertModal('Invalid User Details');
      //     }
      //     this.Loader.hide();
      //   },
      //   err => {
      //     //console.log(err)
      //   }
      // );

      this.ProfileService.GetClientInfobypanno(this.EncrdecrService.setEncr(this.ChangePassForm.value.VERIFICATION_ID), this.UserType).subscribe(
        (res: any) => {
          console.log('GetClientInfobyPann', res);

          try {
            if (res != null) {
              debugger
              if (!isNullOrUndefined(res.data)) {
                var rowData = this.EncrdecrService.getDecr(res.data);
                var APIResponse = JSON.parse(rowData);
                res = APIResponse;
                if (res.ArrayOfResponse.length > 0) {
                  let BasicDetails = res.ArrayOfResponse;
                  this.MobileNo = res.ArrayOfResponse[0].MobileNo;
                  this.SubBrokerId = res.ArrayOfResponse[0].VALUEFIELD;
                  debugger
                  console.log(res.ArrayOfResponse[0].MobileNo);
                  const request = {

                    "FullName": res.ArrayOfResponse[0].Name,
                    "MobileNo": res.ArrayOfResponse[0].MobileNo,
                    //"EmailId": this.OTPType == "EmailID" ? this.BasicDetailsForm.controls['Email'].value : "",
                    "Trans_Type": "Mobile",
                    "Flag": "G",
                    "USER_TYPE": "2",
                    "ForgotPassword": "ForgotPassOTP"
                    //"OTP": this.OTPForm.controls['OTP'].value
                  };
                  let DataBody = JSON.stringify(request);
                  this.ProfileService.SendOTP(DataBody).subscribe(response => {
                    let data = JSON.parse(this.EncrdecrService.getDecr(response))
                    console.log(data.Message);
                    if (data.Message.indexOf('Success') > -1) {
                      this.Loader.hide();
                      this.ActiveOTPTab();
                    }
                    else {
                      this.Loader.hide();
                      this.CallAlertModal("Overlimit")
                    }
                  })

                }
                else {
                  this.Loader.hide();
                  this.CallAlertModal('Invalid User Details');
                }
              }
            }
          }
          catch (err) {
            this.Loader.hide();
          }

        },
        err => {
          //console.log(err)
        }
        //}
      );
    }
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }
  onOtpChange(e) {
    let val = e;
    let v = '';
    v = v + val;
    this.CodifyOTPForm.controls["OTP"].setValue(v);
  }


  onOTPSubmit(): Observable<any> {
    debugger

    this.OTPFormSubmitted = true;
    if (this.OTPForm.invalid) {
      return;
    }
    else {

      this.Loader.show();

      let RandomString = '';
      RandomString = this.generateRandomString(6);

      this.ProfileService.GetClientInfobypanno(this.EncrdecrService.setEncr(this.ChangePassForm.value.VERIFICATION_ID), this.UserType).subscribe(
        (res: any) => {
          try {
            if (res != null) {
              if (!isNullOrUndefined(res.data)) {
                var rowData = this.EncrdecrService.getDecr(res.data);
                var APIResponse = JSON.parse(rowData);
                res = APIResponse;
                if (res.ArrayOfResponse.length > 0) {
                  let BasicDetails = res.ArrayOfResponse;
                  console.log(res.ArrayOfResponse[0].MobileNo);
                  const request = {

                    "FullName": res.ArrayOfResponse[0].Name,
                    "MobileNo": res.ArrayOfResponse[0].MobileNo,
                    //"EmailId": this.OTPType == "EmailID" ? this.BasicDetailsForm.controls['Email'].value : "",
                    "Trans_Type": "Mobile",
                    "Flag": "V",
                    "OTP": this.otp,
                    "RandomKey": RandomString
                  };
                  console.log("this is data: ", request);
                  let DataBody = JSON.stringify(request);

                  this.ProfileService.SendOTP(DataBody).subscribe(response => {
                    this.Loader.hide();
                    debugger
                    let key = '';
                    let message = '';
                    response = JSON.parse(this.EncrdecrService.getDecr(response));
                    response.Message = this.EncrdecrService.getDecr(response.Message)
                    let data = response

                    key = data.Message.split('|')[1]
                    message = data.Message.split('|')[0]
                    if (message == "Verified") {
                      this.ActiveNewPassTab();
                    }
                    else {
                      this.CallAlertModal('Invalid OTP.');
                    }
                  });
                }
              } else {
                this.CallAlertModal("There seems to be a some issue, please try again later.");
              }
            }
          }
          catch (e) {
            this.Loader.hide();
          }

        });
    }
  }
  SetPassFormSubmit() {
    debugger
    this.SetPassFormSubmitted = true;
    if (this.SetPassForm.invalid) {
      return;
    }
    else {

      if (this.SetPassForm.invalid) {
        return;
      }

      else {
        const request = {
          userId: this.ChangePassForm.value.VERIFICATION_ID,
          password: this.SetPassForm.controls["NEW_PASS"].value,
          token: this.ResetPassToken
        }
        console.log("Reset Pass req: ", request)
        var json = JSON.stringify(request);
        this.Loader.show();
        this.LoginService.CodifyResetPassword(json).subscribe(res => {
          if (res != null && res != undefined) {
            this.Loader.hide();
            console.log(res)
            if (res[0].result.message.indexOf('Fail') > -1 || res[0].result.message.indexOf('Error') > -1) {
              this.Loader.hide();
              this.CallAlertModal(res[0].result.message)
            }
            else {
              $("#SuccessSetPassAlertModal").modal({
                backdrop: 'static',
                keyboard: false
              });

            }
          }
          else {

          }
          this.Loader.hide();
          console.log("Response: ", res)
        })
      }

      // else {
      //   ////////
      //   debugger
      //   this.SetPassForm.controls['USER_ID'].setValue(this.SubBrokerId);
      //   this.SetPassForm.controls['OTP'].setValue(this.OTPForm.controls['OTP'].value);
      //   //this.SetPassForm.controls["Password"].setValue(this.EncrdecrService.setEncr(this.SetPassForm.value.Password));
      //   //this.SetPassForm.controls["NEW_PASS"].setValue(this.EncrdecrService.setEncr(this.SetPassForm.value.NEW_PASS));
      //   let tempData = this.SetPassForm.value;
      //   tempData.NEW_PASS = this.EncrdecrService.setEncr(this.SetPassForm.value.NEW_PASS);
      //   tempData.MobileNo = this.MobileNo;
      //   // tempData.Password = this.EncrdecrService.setEncr(this.SetPassForm.value.Password);
      //   // tempData.USER_TYPE = this.EncrdecrService.setEncr(this.SetPassForm.value.USER_TYPE);
      //   // tempData.USER_ID = this.EncrdecrService.setEncr(this.SetPassForm.value.USER_ID);
      //   // tempData.OTP = this.EncrdecrService.setEncr(this.SetPassForm.value.OTP);
      //   // tempData.MobileNo = this.EncrdecrService.setEncr(this.SetPassForm.value.MobileNo);
      //   this.Loader.show()
      //   let DataBody = JSON.stringify(tempData);
      //   console.log(DataBody);
      //   this.LoginService.ChangePassword_NSE(DataBody).subscribe(
      //     (response: any) => {
      //       let res = JSON.parse(this.EncrdecrService.getDecr(response))
      //       this.Loader.hide();
      //       if (res.code == "200") {
      //         $("#SuccessSetPassAlertModal").modal({
      //           backdrop: 'static',
      //           keyboard: false
      //         });
      //       }
      //       else {
      //         this.CallAlertModal("Something went wrong!!")
      //       }
      //     },
      //     err => {
      //       //console.log(err)
      //     }
      //   );
      // }
    }
  }

  ActiveChangePassTab() {
    this.IsChangePass = true;
    this.IsOTPVerify = false;
    this.IsNewPass = false;
  }
  ActiveOTPTab() {
    this.IsChangePass = false;
    this.IsOTPVerify = true;
    this.IsNewPass = false;
  }
  ActiveNewPassTab() {
    this.IsChangePass = false;
    this.IsOTPVerify = false;
    this.IsNewPass = true;
    
  }
  HideModal() {
    $("#SuccessSetPassAlertModal").modal('hide');
  }
  getCompanyDetails() {
    this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe((data: any) => {
      if (data != null && data.ArrayOfResponse.length != 0) {
        sessionStorage.setItem('E#$%#XCha7%*=', data.ArrayOfResponse[0].Dummy2);
        sessionStorage.setItem('Vbhs@#%LMKIo=', data.ArrayOfResponse[0].Dummy1);
        sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(data.ArrayOfResponse[0].EnableRiskProfile));
      }
    });
  }



  generateRandomString(length) {
    let result = '';
    const charactersLength = this.characters.length;
    for (let i = 0; i < length; i++) {
      result += this.characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  GetClientPanInfo(result: any) {
    console.log(this.ChangePassForm.value.VERIFICATION_ID);
    const request = {
      userId: this.ChangePassForm.value.VERIFICATION_ID,
    }

    var json = JSON.stringify(request);

    this.LoginService.GetClientPanInfo(json).then((res1:any) => {
      let res = JSON.parse(this.EncrdecrService.getDecr(res1));
      if (res.ArrayOfResponse.length > 0) {
        console.log("info", res.ArrayOfResponse)
        this.ForgotPassword(res.ArrayOfResponse);
      }
      else {
        if (res.Message == "Client Not found") {
          this.CallAlertModal("Client Not Found.")
        } else {
          this.CallAlertModal(res.Message);
        }
        this.Loader.hide();
      }
    });
  }
  CloseMainModal() {
    this.bsModalRef.hide();
  }
  ForgotPassword(response) {
    this.Loader.show();
    const request = {
      userId: this.ChangePassForm.value.VERIFICATION_ID,
      pan: response[0].PANNo
    }
    var json = JSON.stringify(request);
    this.LoginService.CodifyForgotPassword(json).subscribe(res => {
      console.log("Forgpot pass res", res);
      if (res.length > 0) {
        debugger
        console.log("Response is: ", res)
        if (res[0].result.status == "Success") {
          this.CodifyValidateRes = res[0].result
          $("#AlertModalOTPVerification").modal({
            backdrop: 'static',
            keyboard: false
          });
          let id = $('.ng-otp-input-wrapper .otp-input:first-child').attr('id');
          console.log(id);
          this.ngCodifyOtpInput.focusTo(id);
          if (res[0].result.mobileNumber != null && res[0].result.mobileNumber != "") {
            $('#sendedOTPMobileNumber').text(res[0].result.mobileNumber);
          }
          if (res[0].result.emailId != null && res[0].result.emailId != "") {
            $('#sendedOTPEmailId').text(res[0].result.emailId);
          }
          this.Loader.hide();
        }
        else {
          this.CallAlertModal(res[0].result.message);
          this.Loader.hide();
        }
      }
      else {
        this.CallAlertModal("Something went wrong please try again");
        this.Loader.hide()
      }
    });
  }
  onSubmitVerifyOTP() {
    debugger
    this.OTPFormSubmitted = true;
    this.IsShowInvalidOTPMsg = false;
    if (this.OTPForm.invalid) {
      return;
    } else {
      this.Loader.show()

      const request = {
        userId: this.CodifyValidateRes.userId,
        otp: this.CodifyOTPForm.controls['OTP'].value,
        token: this.CodifyValidateRes.token
      }

      var json = JSON.stringify(request);
      this.LoginService.CodifyVerifyForgotPassword(json).subscribe(res => {
        debugger
        console.log("this is otp verify response: ", res)
        if (res.length > 0) {
          if (res[0].result.message == "Success") {
            if (!this.ForgetPass) {
              this.GetClientPanInfo(res[0].result);

            }
            else {
              this.ResetPassToken = res[0].result.token;
              this.ActiveNewPassTab();
            }

            $("#AlertModalOTPVerification").modal('hide');
            this.Loader.hide();
            setTimeout(() => {
              this.renderer.selectRootElement(this.newpassword.nativeElement).focus();
              // }
            }, 500);
        
          }
          else {
            this.IsShowInvalidOTPMsg = true
            // this.CallAlertModal("Invalid OTP Code");
            this.Loader.hide()
          }
        }
        else {
          this.CallAlertModal("Something went wrong please try again");
          $("#AlertModalOTPVerification").modal('hide')
          this.Loader.hide()
        }
      },
        (err: any) => {
          this.CallAlertModal(err.statusText);
          $("#AlertModalOTPVerification").modal('hide')
          this.Loader.hide()
        }
      );
    }

  }
}
